import { Claims } from '../utils/services/cache/ClientCache'
const axios = require('axios');

export const GetStudentGrowthTraitGroups = async (startDate, endDate, idTraitGroups) => {

    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}Trait/GetStudentGrowthTraitGroups`,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Claims.getToken()}`
        },
        data: {
            startDate,
            enddate: endDate,
            StudentNumber: Claims.getGivenName(),
            TraitGroupId: idTraitGroups
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getAchievementBadgesByStudentNumber = async (data) => {
    data.studentNumber = Claims.getGivenName();
    try {
        const result = await axios({
            method: 'get',
            url: `${process.env.WEB_API}Student/GetAchievementBadgesByStudentNumber`,
            params: data,
            headers: {
                'Authorization': `Bearer ${Claims.getToken()}`
            }
        });
        const response = JSON.parse(result.request.response)
        if (response.status === "Success")
            return response.data;
        else
            return [];

    } catch (error) {
        console.error(error);
    }
};